export default __webpack_public_path__ + "static/media/19.e29b0ac3.jpg";